export default "__VITE_ASSET__g7ewFuYG__"